import { useRef, useState, useCallback, useLayoutEffect, useEffect } from 'react';

function useGradesGridNew() {
  const popperRef = useRef(null);
  const scrollWrapperRef = useRef(null);

  const [scrollLeftButtonEnabled, setScrollLeftButtonEnabled] = useState(false);
  const [scrollRightButtonEnabled, setScrollRightButtonEnabled] = useState(false);

  const onScroll = useCallback(() => {
    const el = scrollWrapperRef.current;

    if (el.scrollWidth <= el.offsetWidth) {
      setScrollLeftButtonEnabled(false);
      setScrollRightButtonEnabled(false);
    } else if (el.scrollLeft <= 0) {
      setScrollLeftButtonEnabled(false);
      setScrollRightButtonEnabled(true);
    } else if (el.scrollLeft + el.clientWidth >= el.scrollWidth) {
      setScrollLeftButtonEnabled(true);
      setScrollRightButtonEnabled(false);
    } else {
      setScrollLeftButtonEnabled(true);
      setScrollRightButtonEnabled(true);
    }
  }, [scrollWrapperRef, setScrollLeftButtonEnabled, setScrollRightButtonEnabled]);

  // Run onScroll on initialisation
  useLayoutEffect(() => onScroll(), [onScroll]);
  // Attach window resize handler for onScroll
  useEffect(() => {
    window.addEventListener('resize', onScroll);
    return () => window.removeEventListener('resize', onScroll);
  }, [onScroll]);

  const scrollRight200 = useCallback(() => {
    const el = scrollWrapperRef.current;
    if (el.scrollTo) {
      el.scrollTo({ left: el.scrollLeft + 200, behavior: 'smooth' });
    } else {
      el.scrollLeft += 200;
    }
  }, [scrollWrapperRef]);

  const scrollLeft200 = useCallback(() => {
    const el = scrollWrapperRef.current;
    if (el.scrollTo) {
      el.scrollTo({ left: el.scrollLeft - 200, behavior: 'smooth' });
    } else {
      el.scrollLeft -= 200;
    }
  }, [scrollWrapperRef]);

  return {
    popperRef,
    scrollWrapperRef,
    scrollLeftButtonEnabled,
    scrollRightButtonEnabled,
    onScroll,
    scrollRight200,
    scrollLeft200,
  };
}

export default useGradesGridNew;
